/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Default_DescriptionInputs */

const en_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year. Private golf lessons in Des Moines from Mark Egly, Golf Digest's #1 Iowa instructor. The Egly Method, built from decades of teaching.`)
};

const es_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesor del Año de la Iowa PGA. Lecciones privadas de golf en Des Moines con Mark Egly, el instructor #1 de Iowa según Golf Digest. El método Egly, construido con décadas de enseñanza.`)
};

const de_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrer des Jahres der Iowa PGA. Private Golfstunden in Des Moines bei Mark Egly, laut Golf Digest der führende Golflehrer in Iowa. Die Egly-Methode, entstanden aus jahrzehntelanger Lehrerfahrung.`)
};

const zh_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 年度最佳教师。得梅因的私人高尔夫课程，由 Golf Digest 评选的爱荷华州排名第一的教练 Mark Egly 授课。Egly Method 是经过数十年的教学而建立的。`)
};

const ar_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلم العام في Iowa PGA. دروس غولف خاصة في Des Moines مع Mark Egly، المدرب رقم 1 في Iowa حسب Golf Digest. منهج Egly، مبني على عقود من التعليم.`)
};

const fr_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignant de l’année de la Iowa PGA. Cours de golf privés à Des Moines avec Mark Egly, instructeur n°1 de l'Iowa selon Golf Digest. La méthode Egly, fruit de plusieurs décennies d'enseignement.`)
};

const vi_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giáo viên của năm của Iowa PGA. Buổi học golf riêng tại Des Moines với Mark Egly, huấn luyện viên số 1 Iowa theo Golf Digest. Phương pháp Egly, xây dựng từ hàng chục năm giảng dạy.`)
};

const sw_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwalimu Bora wa Mwaka wa Iowa PGA. Masomo binafsi ya gofu huko Des Moines na Mark Egly, mwalimu nambari 1 wa Iowa kwa mujibu wa Golf Digest. Mbinu ya Egly, iliyojengwa kwa miongo ya ufundishaji.`)
};

const th_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ครูแห่งปีของ Iowa PGA บทเรียนกอล์ฟแบบส่วนตัวในดิมอยน์กับ Mark Egly ผู้ฝึกสอนอันดับ 1 ของรัฐไอโอวาตาม Golf Digest Egly Method สร้างขึ้นจากประสบการณ์การสอนหลายทศวรรษ`)
};

const bs_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitelj godine Iowa PGA. Privatne lekcije golfa u Des Moinesu kod Marka Eglyja, instruktora broj 1 u Iowi prema Golf Digestu. Egly metoda, izgrađena na decenijama podučavanja.`)
};

const ja_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 年間最優秀教師。Golf Digest #1 アイオワインストラクター、Mark Eglyによるデモインのプライベートゴルフレッソン。Egly Methodは、数十年の指導から築かれています。`)
};

const ko_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 올해의 교사. Des Moines에서 Mark Egly의 프라이빗 골프 레슨, Golf Digest #1 Iowa 강사. Egly 메서드는 수십 년의 가르침으로 만들어졌습니다.`)
};

const pt_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professor do Ano da Iowa PGA. Aulas particulares de golfe em Des Moines com Mark Egly, o instrutor nº 1 de Iowa segundo a Golf Digest. O Egly Method, construído a partir de décadas de ensino.`)
};

const it_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insegnante dell’anno della Iowa PGA. Lezioni di golf private a Des Moines con Mark Egly, istruttore #1 dell’Iowa per Golf Digest. L’Egly Method, costruito in decenni di insegnamento.`)
};

const sv_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets lärare i Iowa PGA. Privata golflektioner i Des Moines med Mark Egly, Golf Digests nr 1-instruktör i Iowa. Egly Method, byggd på årtionden av undervisning.`)
};

const nl_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leraar van het Jaar van de Iowa PGA. Privé-golflessen in Des Moines bij Mark Egly, volgens Golf Digest de nummer 1 golfleraar van Iowa. De Egly Method, gebouwd op tientallen jaren lesgeven.`)
};

const da_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets træner i Iowa PGA. Private golflektioner i Des Moines hos Mark Egly, Golf Digests nr. 1-instruktør i Iowa. Egly Method, bygget på årtiers undervisning.`)
};

const nb_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets lærer i Iowa PGA. Private golftimer i Des Moines hos Mark Egly, Golf Digests nr. 1-instruktør i Iowa. Egly Method, bygget på flere tiår med undervisning.`)
};

const fi_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:n vuoden opettaja. Yksityisiä golftunteja Des Moinesissa Mark Eglyltä, Golf Digestin Iowan ykkösvalmentajalta. Egly Method perustuu vuosikymmenten opetuskokemukseen.`)
};

const pl_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauczyciel Roku Iowa PGA. Prywatne lekcje golfa w Des Moines – prowadzi je Mark Egly, instruktor nr 1 w Iowa według Golf Digest. Egly Method, zbudowana na dziesięcioleciach nauczania.`)
};

const ru_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учитель года Iowa PGA. Частные уроки гольфа в Des Moines с тренером Mark Egly — инструктором №1 в Iowa по версии Golf Digest. Egly Method, созданный за десятилетия преподавания.`)
};

const tr_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Yılın Öğretmeni. Des Moines'te Mark Egly ile özel golf dersleri; Golf Digest'e göre Iowa'nın 1 numaralı eğitmeni. Egly Method, onlarca yıllık öğretim deneyimiyle oluşturuldu.`)
};

const hi_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA वर्ष के सर्वश्रेष्ठ शिक्षक। Des Moines में Mark Egly से निजी गोल्फ पाठ, जो Golf Digest के अनुसार Iowa के #1 प्रशिक्षक हैं। Egly Method, दशकों के अध्यापन से विकसित।`)
};

const id_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year. Les golf privat di Des Moines bersama Mark Egly, instruktur #1 Iowa versi Golf Digest. Egly Method, dibangun dari puluhan tahun mengajar.`)
};

const ms_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year. Pelajaran golf persendirian di Des Moines bersama Mark Egly, jurulatih #1 Iowa versi Golf Digest. Egly Method, dibina daripada berdekad-dekad pengalaman mengajar.`)
};

const cs_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitel roku Iowa PGA. Soukromé lekce golfu v Des Moines s Markem Eglym, podle Golf Digest instruktorem č. 1 v Iowě. Egly Method, postavená na desetiletích výuky.`)
};

const el_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δάσκαλος της Χρονιάς της Iowa PGA. Ιδιωτικά μαθήματα γκολφ στο Des Moines με τον Mark Egly, τον εκπαιδευτή #1 της Iowa κατά το Golf Digest. Η Μέθοδος Egly, χτισμένη σε δεκαετίες διδασκαλίας.`)
};

const he_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מורה השנה של Iowa PGA. שיעורי גולף פרטיים ב-Des Moines עם Mark Egly, המדריך מס' 1 ב-Iowa לפי Golf Digest. Egly Method, שנבנתה מעשרות שנות הוראה.`)
};

const af_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Onderwyser van die Jaar. Privaat gholflessies in Des Moines by Mark Egly, Golf Digest se #1 Iowa-instrukteur. Die Egly-metode, gebou uit dekades van onderrig.`)
};

const hu_meta_default_description = /** @type {(inputs: Meta_Default_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa PGA év tanára. Privát golfórák Des Moines-ban Mark Eglyvel, a Golf Digest szerint Iowa első számú oktatójával. Az Egly Method több évtizednyi tanítási tapasztalatra épül.`)
};

/**
* | output |
* | --- |
* | "Iowa PGA Teacher of the Year. Private golf lessons in Des Moines from Mark Egly, Golf Digest's #1 Iowa instructor. The Egly Method, built from decades of tea..." |
*
* @param {Meta_Default_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const meta_default_description = /** @type {((inputs?: Meta_Default_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Default_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_default_description(inputs)
	if (locale === "de") return de_meta_default_description(inputs)
	if (locale === "zh") return zh_meta_default_description(inputs)
	if (locale === "ar") return ar_meta_default_description(inputs)
	if (locale === "fr") return fr_meta_default_description(inputs)
	if (locale === "vi") return vi_meta_default_description(inputs)
	if (locale === "sw") return sw_meta_default_description(inputs)
	if (locale === "th") return th_meta_default_description(inputs)
	if (locale === "bs") return bs_meta_default_description(inputs)
	if (locale === "ja") return ja_meta_default_description(inputs)
	if (locale === "ko") return ko_meta_default_description(inputs)
	if (locale === "pt") return pt_meta_default_description(inputs)
	if (locale === "it") return it_meta_default_description(inputs)
	if (locale === "sv") return sv_meta_default_description(inputs)
	if (locale === "nl") return nl_meta_default_description(inputs)
	if (locale === "da") return da_meta_default_description(inputs)
	if (locale === "nb") return nb_meta_default_description(inputs)
	if (locale === "fi") return fi_meta_default_description(inputs)
	if (locale === "pl") return pl_meta_default_description(inputs)
	if (locale === "ru") return ru_meta_default_description(inputs)
	if (locale === "tr") return tr_meta_default_description(inputs)
	if (locale === "hi") return hi_meta_default_description(inputs)
	if (locale === "id") return id_meta_default_description(inputs)
	if (locale === "ms") return ms_meta_default_description(inputs)
	if (locale === "cs") return cs_meta_default_description(inputs)
	if (locale === "el") return el_meta_default_description(inputs)
	if (locale === "he") return he_meta_default_description(inputs)
	if (locale === "af") return af_meta_default_description(inputs)
	if (locale === "hu") return hu_meta_default_description(inputs)
	return en_meta_default_description(inputs)
});